import React from 'react';
import { mergeClasses } from '@fluentui/react-components';
import './GuideComponents.css';

export interface GuideSectionTitleProps {
  title: React.ReactNode;
  /** Nivel del encabezado (por defecto h3). El tamaño es siempre 16 / Bold. */
  as?: 'h2' | 'h3' | 'h4';
  id?: string;
  /** Ayuda junto al título, normalmente un `GuideHelpPopover`. */
  help?: React.ReactNode;
  /** Descripción debajo (13 / Regular, texto secundario). */
  description?: React.ReactNode;
  /** Acciones a la derecha (botones sutiles / secundarios). */
  actions?: React.ReactNode;
  className?: string;
}

/**
 * Título de sección de la guía ("Tipografía": 16 / Bold) con ayuda (?) opcional, descripción
 * secundaria debajo y acciones a la derecha.
 */
export const GuideSectionTitle = ({ title, as: Heading = 'h3', id, help, description, actions, className }: GuideSectionTitleProps) => (
  <div className={mergeClasses('ichtys-section-title', className)}>
    <div>
      <Heading className="ichtys-section-title__heading" id={id}>
        {title}
        {help}
      </Heading>
      {description && <p className="ichtys-section-title__description">{description}</p>}
    </div>
    {actions && <div className="ichtys-section-title__actions">{actions}</div>}
  </div>
);

export default GuideSectionTitle;
